/**
 * Human-readable labels for known payment/payout provider drivers.
 * Used wherever the UI needs to display a provider name from a `driver` string.
 */
export const PROVIDER_LABELS: Record<string, string> = {
  paypal: 'PayPal',
  xendit: 'Xendit',
};

/**
 * Returns a human-readable label for the given driver string.
 * Falls back to capitalising the raw driver value when the driver is unknown.
 */
export function getProviderLabel(driver: string): string {
  return PROVIDER_LABELS[driver] ?? driver.charAt(0).toUpperCase() + driver.slice(1);
}

/**
 * Human-readable labels for known Xendit sub-method codes.
 * Matches the seed method list from the backend's `payment_method_settings` table.
 */
export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  CREDIT_CARD: 'Credit Card',
  GCASH: 'GCash',
  GRABPAY: 'GrabPay',
  PAYMAYA: 'PayMaya',
  QRPH: 'QR Ph',
};

/**
 * Returns a user-facing label for a payment's method. When the payment carries
 * a Xendit sub-method code (e.g. "GCASH"), returns the method name. When no
 * sub-method is set (PayPal), falls back to the driver's display name.
 */
export function getPaymentLabel(driver: string, paymentMethod: string | null): string {
  if (paymentMethod) {
    return PAYMENT_METHOD_LABELS[paymentMethod] ?? paymentMethod;
  }
  return getProviderLabel(driver);
}
